import React, { useContext } from 'react'
import Button from '@material-ui/core/Button'
import Link from '@material-ui/core/Link'
import RenderEmoji from './RenderEmoji'
import { makeStyles } from '@material-ui/core/styles'
import { SessionContext } from './session-context'
import { handleButtonPush } from './js/data-providers'

const useStyles = makeStyles(theme => ({
  buttonText: {
    textTransform: 'none'
  }
}))

function CTAButton (props) {
  const { token, chatServiceUrl } = useContext(SessionContext)
  const classes = useStyles()
  const conversationEvent = props.conversation_event
  const target = conversationEvent.attributes.data.open_target || '_parent'

  return (
    <div>
      <Button
        component={Link}
        target={target}
        rel='noopener'
        href={conversationEvent.attributes.data.url}
        style={{
          backgroundColor: conversationEvent.attributes.data.color,
          color: 'white',
          width: '90%',
          marginTop: 10,
          marginBottom: 10,
          marginLeft: 'auto',
          marginRight: 'auto',
          display: 'block',
          textAlign: 'center',
          fontWeight: 'bold'
        }}
        variant='outlined'
        onClick={() => {
          handleButtonPush({ token, chatServiceUrl, conversationID: conversationEvent.relationships.conversation.data.id, buttonID: conversationEvent.relationships.conversation.data.id })
        }}
      >
        <RenderEmoji
          text={conversationEvent.attributes.data.label}
          className={classes.buttonText}
        />
      </Button>
    </div>
  )
}

export default CTAButton
